//@ts-nocheck
import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const getCompetenceAreas = async () => {
  const { data } = await axios.get(`/api/competence_areas`);

  return data;
};

export const useCompetenceAreas = () => {
  return useQuery('competences',
    () => getCompetenceAreas(), {
    select: ({ data: competences }) => ({ competences }),
    initialData: {
      competences: [],
    },
  });
};